import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { userStateBaseGuard } from './user-state-base.guard';

export const CustomerAdminRequiredGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return userStateBaseGuard()?.isLCAAdmin || userStateBaseGuard()?.isCustomerAdmin;
}